<template>
  <InputField
    type="text"
    :id="id"
    :placeholder="placeholder"
    :invalid-feedback="invalidFeedback"
    :value="formattedValue"
    @update:model-value="handleInput"
    @keydown="validateNumber"
  />
</template>

<script>
import InputField from "./InputField.vue"
import { computed } from "vue"

export default {
  name: "PhoneInput",
  components: {
    InputField
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    invalidFeedback: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const modelValue = computed(() => props.value)

    const formattedValue = computed(() => {
      if (!modelValue.value) return ""
      const digitsOnly = modelValue.value.replace(/\D/g, "")
      let formattedNumber = "(" + digitsOnly.substring(0, 3)
      if (digitsOnly.length > 3) {
        formattedNumber += ") " + digitsOnly.substring(3, 6)
      }
      if (digitsOnly.length > 6) {
        formattedNumber += "-" + digitsOnly.substring(6, 10)
      }
      if (digitsOnly.length > 10) {
        formattedNumber += digitsOnly.substring(10)
      }
      return formattedNumber
    })

    const handleInput = (value) => {
      const digitsOnly = value.replace(/\D/g, "")
      let formattedNumber = "(" + digitsOnly.substring(0, 3)
      if (digitsOnly.length > 3) {
        formattedNumber += ") " + digitsOnly.substring(3, 6)
      }
      if (digitsOnly.length > 6) {
        formattedNumber += "-" + digitsOnly.substring(6, 10)
      }
      if (digitsOnly.length > 10) {
        formattedNumber += digitsOnly.substring(10)
      }
      emit("update:modelValue", formattedNumber)
    }

    const validateNumber = (event) => {
      const input = event?.target?.value || ""
      const inputLength = input.replace(/\D/g, "").length
      const key = event?.key || ""
      const keyCode = event?.keyCode

      // Always allow keyboard navigation and editing controls to avoid focus trapping.
      const allowedControlKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Tab",
        "Enter",
        "Escape"
      ]
      if (allowedControlKeys.includes(key)) return

      // Allow common shortcuts: copy, paste, cut, select-all.
      if (event?.ctrlKey || event?.metaKey) return

      const isNumericKey =
        (keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)

      // Check if the first number is 0.
      if (inputLength === 0 && (keyCode === 48 || keyCode === 96)) {
        event.preventDefault()
        return
      }

      // Allow only numbers and prevent more than 10 digits.
      if (!isNumericKey || inputLength >= 10) {
        event.preventDefault()
      }
    }

    return {
      formattedValue,
      handleInput,
      validateNumber
    }
  }
}
</script>
